import { useState } from "react";
import { Trash2, Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

export function DeleteClientDialog({ open, onOpenChange, clientName, onConfirm }) {
  const [typed, setTyped] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = typed.trim() === clientName;

  const confirm = async () => {
    setBusy(true);
    try { await onConfirm(typed.trim()); } finally { setBusy(false); }
  };

  return (
    <AlertDialog open={open} onOpenChange={(v) => { setTyped(""); onOpenChange(v); }}>
      <AlertDialogContent data-testid="delete-client-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminar cliente y todo su historial</AlertDialogTitle>
          <AlertDialogDescription>
            Se borrarán de forma permanente el cliente <b>{clientName}</b>, sus activos, hallazgos, escaneos,
            calificaciones, informes y usuarios cliente. Esta acción no se puede deshacer.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <label className="block">
          <div className="font-mono text-[10px] tracking-widest uppercase text-muted-foreground mb-1">
            Escribe el nombre del cliente para confirmar
          </div>
          <input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={clientName}
                 className="w-full bg-background border border-border px-3 py-2 text-sm font-mono focus:border-sev-critical outline-none"
                 data-testid="delete-client-confirm-input" />
        </label>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-client-cancel">Cancelar</AlertDialogCancel>
          <button onClick={confirm} disabled={!ok || busy}
                  className="bg-sev-critical text-white px-4 py-2 text-sm disabled:opacity-40 inline-flex items-center gap-2"
                  data-testid="delete-client-confirm-btn">
            {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Trash2 className="w-3 h-3" />} Eliminar definitivamente
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
